export const GET_user = ({ user }) => user
export const GET_token = ({ token }) => token
export const GET_email = ({ email }) => email
export const GET_password = ({ password }) => password
export const GET_process = ({ process }) => process
export const GET_successMessage = ({ successMessage }) => successMessage
export const GET_errorMessage = ({ errorMessage }) => errorMessage
export const GET_DialodPermissionDenied = ({ DialodPermissionDenied }) => DialodPermissionDenied
